"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import loadScript from "@elements/load-script";
import {find, findAll, on, toggleClass} from "@elements/dom-utils";

const selectors = {
    widgetId: '#aic-chat-widget-id',
    wrapperOverlay: '.aic-chat-widget__wrapper',
    button: '.aic-chat-widget__activate-button'
}
export function init () {
    let isMounted = false;
    let widgetInstance = null;
    let chatModuleRegistered = false;

    on("cf_init", function() {
        // CookieFirst.consent && CookieFirst.consent.advertising && cb();
        cb();
    }, window)

    on('cf_consent', (event) => {
        // event.detail.advertising && cb();
        cb();
    }, window);

    function cb() {
        if(chatModuleRegistered) {
            return;
        }

        chatModuleRegistered = true;
        onFind(".js-open-chat-link", function (chatLink) {
            console.log("new ai concierge being loaded")
            loadScript('https://concierge.goodguys.ai/aiconcierge_client_v2/chat-widget.umd.js').then(function () {
                loadConciergeIcon();

                onFind(selectors.button, function(button) {
                    on('click', () => {
                        if(widgetInstance) {
                            isMounted ? toggleOverlayVisibility() : widgetInstance.mount();
                            isMounted = true;
                        }
                    }, button)
                });
            })
        });
    }

    function loadConciergeIcon() {
        if(!ChatWidgetModule) {
            console.log("ChatWidgetModule not found");
            return;
        }

        widgetInstance = new ChatWidgetModule.ChatWidget({
            projectId: "6554cac3892c9d5bfdb43388",
            hideAvatar: true,
            onClose: () => {
                console.log("close function")
                toggleOverlayVisibility();
            }
        })
    }

    const toggleOverlayVisibility = () => {
        const overlay = find(selectors.widgetId);

        if(overlay) {
            toggleClass('aic-chat-widget--overlay-hidden', overlay);
        }
    }
}